<template>
    <CadastroPadrao :cabecalho="state.cabecalho" :linhas="state.linhas" :url="state.url" :titulo="state.titulo"
        :limparInput="limparInput" :objeto="state.objetoAuxiliar">
        <template v-slot:ficha>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Código
                </label>
                <div class="col inp">
                    <input type="text" class="form-control" v-model="state.objetoAuxiliar.id" disabled>
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Descrição
                </label>
                <div class="col inp">
                    <input type="text" class="form-control" v-model="state.objetoAuxiliar.descricao"
                        placeholder="Descrição">
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Ativo
                </label>
                <div class="col inp">
                    <input type="checkbox" class="form-check-input" v-model="state.objetoAuxiliar.ativo">
                </div>
            </div>
        </template>
    </CadastroPadrao>
</template>

<script setup>
import CadastroPadrao from '@/components/CadastroPadrao.vue';
import store from '@/store/store';
import { reactive, onMounted, computed } from 'vue';

const state = reactive({
    cabecalho: ['Código'],
    linhas: ['id'],
    url: "Responsavel",
    titulo: "Cadastro de Responsável",
    objetoAuxiliar: {
        ativo: Boolean()
    },
    setoresAtivos: []
});
async function limparInput(pObj) {
    state.setoresAtivos = state.setor.filter(s => s.ativo === true);
    if (pObj) {
        state.objetoAuxiliar = pObj;
    } else {
        state.objetoAuxiliar = {};
        let maiorId = 0;
        setor.value.forEach(s => {
            if (maiorId < s.id) {
                maiorId = s.id;
            }
        });
        state.objetoAuxiliar.id = maiorId + 1;
    }
}
const setor = computed(() => {
    return store.state.setores;
});
</script>

<style scoped>
.lbl {
    max-width: 35%;
    line-height: 35px;
}
</style>